import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function userLogin(data) {
  const url = `${API_BASE_URL}/auth/login`;
  return request({
    url,
    method: "post",
    data,
  });
}
